import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

const propTypes = {
  onOk: PropTypes.func,//确定按钮钩子函数
  onCancel: PropTypes.func,//取消按钮钩子函数
  backdrop: PropTypes.bool,  //是否弹出遮罩层/遮罩层点击是否触发关闭
  title: PropTypes.string, // modal标题
  okName: PropTypes.string, // modal确认按钮中文字内容
  cancelName: PropTypes.string, // modal取消按钮中文字内容
  showModal: PropTypes.bool,  // 遮罩层显示
  close: PropTypes.func,// 关闭弹框钩子函数
}

const defaultProps = {
  classnames: '',
  backdrop: true,
}

class ModalWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      title: props.title,
      okName: props.okName,
      cancelName: props.cancelName,
      backdrop: props.backdrop,
      maskClosable: props.maskClosable || true,
      onOk: props.onOk,
      onCancel: props.onCancel
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      title,
      okName,
      cancelName,
      backdrop,
      onOk,
      onCancel,
      showModal,
      close
    } = nextProps

    const {
      title1,
      okName1,
      cancelName1,
      backdrop1,
      onOk1,
      onCancel1,
      showModal1,
      close1
    } = this.props

    if (title !== title1
      || okName !== okName1
      || cancelName !== cancelName1
      || backdrop !== backdrop1
      || onOk !== onOk1
      || onCancel !== onCancel1
      || showModal !== showModal1
      || close !== close1) {
      this.setState({
        title,
        okName,
        cancelName,
        backdrop,
        onOk,
        onCancel,
        showModal,
        close
      })
    }

  }

  render() {
    const {
      title,
      okName,
      cancelName,
      backdrop,
      onOk,
      onCancel,
      showModal,
      close,
      maskClosable
    } = this.state
    return (
      <Modal
        title={title}
        className="ac-input-locale-modal"
        visible={showModal}
        onOk={onOk}
        onCancel={onCancel}
        width={600}
        maskClosable={maskClosable}
        // height={680}
        okText={okName}
        cancelText={cancelName}
      >
        {
          this.props.children
        }
      </Modal>
    )

  }
}

ModalWrap.propTypes = propTypes;
ModalWrap.defaultProps = defaultProps;

export default ModalWrap;
